/** Stable permission keys — must match functions/src/access/permissionKeys.js */
export const PERMISSION_KEYS = {
  CORE_ACCESS: 'core.access',
  CONTENT_LIBRARY_ACCESS: 'contentLibrary.access',
  TRANSFORM_ACCESS: 'transform.access',
  ADMIN_CENTER_ACCESS: 'adminCenter.access',
  CONTENT_MANAGER_ACCESS: 'contentManager.access',
  PLATFORM_ADMIN_ACCESS: 'platformAdmin.access'
}

/** Not assignable to agency-wide modules — reserved for per-user roles. */
export const AGENCY_MODULE_FORBIDDEN_PERMISSION_KEYS = [
  PERMISSION_KEYS.PLATFORM_ADMIN_ACCESS,
  PERMISSION_KEYS.ADMIN_CENTER_ACCESS,
  PERMISSION_KEYS.CONTENT_MANAGER_ACCESS
]

/** Not assignable via Agency Admin Tool per-user editor. */
export const AGENCY_USER_ACCESS_FORBIDDEN_PERMISSION_KEYS = [
  PERMISSION_KEYS.PLATFORM_ADMIN_ACCESS,
  PERMISSION_KEYS.CONTENT_MANAGER_ACCESS
]
